import * as PIXI from 'pixi.js';
import { Config } from '../../../video-data/config';

import { BooleanAttribute, ColorAttribute, getAttributesToSerialize } from '../../attributes';
import { rgb2int } from '../../../libs/videoData';
import { Filter } from '../Filter';
import type { BaseSettings } from '../../TimeAwareBase';
import { ColorChannelMapPixiFilter } from './ColorChannelMapPixiFilter';

export class ColorChannelMapFilter extends Filter {
    override _classType = Config.COLOR_CHANNEL_MAP_FILTER;
    override pixiFilter: ColorChannelMapPixiFilter;

    @ColorAttribute()
    redChannelTargetColor = rgb2int([255, 0, 0]);
    @ColorAttribute()
    greenChannelTargetColor = rgb2int([0, 255, 0]);
    @ColorAttribute()
    blueChannelTargetColor = rgb2int([0, 0, 255]);
    @BooleanAttribute()
    isRedChannelMappedToAlpha = false;
    @BooleanAttribute()
    isGreenChannelMappedToAlpha = false;
    @BooleanAttribute()
    isBlueChannelMappedToAlpha = false;

    constructor(settings: BaseSettings) {
        super(settings);
        this.pixiFilter = new ColorChannelMapPixiFilter();
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(
            getAttributesToSerialize(this)
        );
    }

    override _update() {
        this.pixiFilter.uniforms.redChannelTargetColor = PIXI.utils.hex2rgb(this.redChannelTargetColor);
        this.pixiFilter.uniforms.greenChannelTargetColor = PIXI.utils.hex2rgb(this.greenChannelTargetColor);
        this.pixiFilter.uniforms.blueChannelTargetColor = PIXI.utils.hex2rgb(this.blueChannelTargetColor);
        this.pixiFilter.uniforms.isRedChannelMappedToAlpha = this.isRedChannelMappedToAlpha;
        this.pixiFilter.uniforms.isGreenChannelMappedToAlpha = this.isGreenChannelMappedToAlpha;
        this.pixiFilter.uniforms.isBlueChannelMappedToAlpha = this.isBlueChannelMappedToAlpha;
    }
}
